import { render, staticRenderFns } from "./ReviewWorkOrder.vue?vue&type=template&id=6c6af3b0"
import script from "./ReviewWorkOrder.vue?vue&type=script&lang=js"
export * from "./ReviewWorkOrder.vue?vue&type=script&lang=js"
import style0 from "./ReviewWorkOrder.vue?vue&type=style&index=0&id=6c6af3b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports